/* global translations */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import { withResizeDetector } from 'react-resize-detector/build/withPolyfill';
import MemberStore from '../../stores/MemberStore';
import MembersActionCreators from '../../actions/MembersActionCreators';
import MembersGrid from '../../components/member';
import { ImageSvg } from '../../components/image';
import Pagination from '../../components/pagination';
import responsiveness from '../../../../../sass/foundation/variables/responsiveness.scss';

class MembersGridContainer extends Component {
  constructor(props) {
    super(props);
    this.membersGrid = React.createRef();
  }

  state = {
    members: {},
    page: this.props.page,
    loading: MemberStore.getLoading(),
    usersNotFound: false,
    error: false,
    showDistance: false,
  };

  componentDidMount() {
    let { page } = this.props;
    page = parseInt(page, 10);

    const {
      membersId,
      paginationUrl,
      checkShowDistance,
      totalItemsCount,
      itemsCountPerPage,
      section,
    } = this.props;

    if (page !== 1) {
      MemberStore.setFetchedMembersPage(page);
      if (page > MemberStore.getBiggestActivePage(section)) {
        MemberStore.setBiggestActivePage(page, section);
      }
    }

    if (totalItemsCount !== 0 && totalItemsCount !== false) {
      const biggestActivePage = Math.ceil(totalItemsCount / itemsCountPerPage);
      MemberStore.setBiggestActivePage(biggestActivePage, section);
      if (biggestActivePage <= 10) {
        MemberStore.setMorePages(false, section);
      }
    }

    MemberStore.removeFetchedMemberIdsPage('all');
    MemberStore.addChangeListener(this.onChange);
    MemberStore.addChangeMemberListener(this.onChangeMember);
    MembersActionCreators.loadLocalFetchedMembers(membersId, page, paginationUrl);

    this.setState({ // eslint-disable-line react/no-did-mount-set-state
      members: MemberStore.getAllFetched(membersId),
      page,
      showDistance: checkShowDistance ? MemberStore.getShowDistance() : false,
    });
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { paginationUrl } = this.props;

    if (window.history.pushState && (nextProps.paginationUrl !== paginationUrl)) {
      const url = nextProps.paginationUrl.replace('.json', ''); // eslint-disable-line prefer-template
      const historyState = {
        id: (new Date()).getTime(),
        url,
        container: '#content',
      };
      window.history.pushState(historyState, '', url);
    }

    this.setState({
      loading: MemberStore.getLoading(),
      usersNotFound: MemberStore.getUsersNotFound(),
      error: MemberStore.getError(),
    });
  }

  componentWillUnmount() {
    MemberStore.removeChangeListener(this.onChange);
    MemberStore.removeChangeMemberListener(this.onChangeMember);
  }

  onChange = () => {
    let members;
    let page = 1;
    if (this.props.pagination) {
      members = MemberStore.getFetchedPage();
      page = MemberStore.getFetchedMembersPage();
      const biggestActivePage = MemberStore.getBiggestActivePage(this.props.section);
      if (biggestActivePage === 1 || biggestActivePage < page) {
        const lastPage = Object.keys(members).length < this.props.itemsCountPerPage;
        MemberStore.setBiggestActivePage(page, this.props.section);
        MemberStore.setMorePages(!lastPage, this.props.section);
      }
    } else {
      MemberStore.setLoadNextPage(false);
      members = MemberStore.getAllFetched(this.props.membersId);
    }

    this.setState({
      page,
      members,
      loading: MemberStore.getLoading(),
      usersNotFound: this.props.checkErrors ? MemberStore.getUsersNotFound() : false,
      error: this.props.checkErrors ? MemberStore.getError() : false,
      showDistance: this.props.checkShowDistance ? MemberStore.getShowDistance() : false,
    });
  };

  onChangeMember = () => {
    const memberIds = map(this.state.members, '_id');
    if (!memberIds.length) {
      return;
    }
    this.setState({
      members: MemberStore.getAllFetched(JSON.stringify(memberIds)),
    });
  };

  updateQueryStringParameter = (uri, key, value) => {
    const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
    const separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
      return uri.replace(re, `$1${key}=${value}$2`);
    }
    return `${uri + separator + key}=${value}`;
  };

  handlePageChange = (page) => {
    clearTimeout(this.pageChangeTimeout);

    // Ja jau kaut ko lādē, tad pagaida, kad tiks pabeigts,
    // lai neveiktu jaunus pieprasījumus, kamēr nav pabeigti iepriekšējie.
    if (MemberStore.getLoading()) {
      // Neveic arī nākamās lapas ielādi iepriekšējam pieprasījumam,
      // lai ātrāk ielādē to, kura nepieciešama tagad.
      // Iespējams, tā arī ir nākamā, un tad sanāktu lādēt vienu un to pašu divreiz
      MemberStore.setLoadNextPage(false);
      this.pageChangeTimeout = setTimeout(() => { this.handlePageChange(page); }, 100);
      return;
    }

    MemberStore.setLoadNextPage(true);

    this.setState({
      loading: true,
    });

    // TODO
    // Ja nav search, tad šobrīd vienkārši lādē normāli nākamo lapu.
    /* if (this.props.type !== 'regular' && this.props.type !== 'admin') {
      let url = window.location.href;
      url = this.updateQueryStringParameter(url, 'page', page);
      window.location = url;
      return;
    } */

    MemberStore.setLoading(true);
    MemberStore.setFetchedMembersPage(page);

    if (MemberStore.getFetchedMemberPage(page) === false) {
      MembersActionCreators.loadFetchedMembers(page, null, this.props.paginationUrl);
    } else {
      MembersActionCreators.loadFetchedMembersPage(page, this.props.paginationUrl);
    }

    let url = window.location.href;
    url = this.updateQueryStringParameter(url, 'page', page);

    if (window.history.pushState) {
      const historyState = {
        id: (new Date()).getTime(),
        url,
        container: '#content',
      };
      window.history.pushState(historyState, '', url);
    }

    const gridContainer = this.membersGrid.current;
    gridContainer.scrollIntoView();
  };

  render() {
    const {
      itemsCountPerPage,
      pagination,
      headerTitle,
      headerShowAll,
      customImages,
      type,
      subtype,
      extended,
      totalItemsCount: totalItemsCountFromProps,
      slider,
      sliderAutoplay,
      menuType,
      section,
      slideTotalResponsive,
    } = this.props;

    const {
      loading,
      usersNotFound,
      error,
      showDistance,
      members,
      page: activePage,
    } = this.state;

    let { slideTotal } = this.props;
    if (slideTotalResponsive && window.innerWidth <= responsiveness.breakpoint) {
      slideTotal = slideTotalResponsive;
    }

    const membersLength = Object.keys(members).length;
    const self = this;
    let totalItemsCount = (itemsCountPerPage * activePage) + 1;
    let topNr;

    if (totalItemsCountFromProps !== 0 && totalItemsCountFromProps !== false) {
      totalItemsCount = totalItemsCountFromProps;
    } else {
      const totalItemsCountFromStore = MemberStore.getTotalItemsCount(section);
      if (totalItemsCountFromStore) {
        totalItemsCount = totalItemsCountFromStore;
      }
    }

    if (type === 'top') {
      topNr = (activePage - 1) * itemsCountPerPage;
    }

    let lastPage = false;

    if (activePage !== 1 && membersLength < itemsCountPerPage) {
      totalItemsCount = itemsCountPerPage * activePage;
      lastPage = true;
    }

    const getBlockHeader = function getBlockHeader() {
      if (headerTitle.length === 0) {
        return ('');
      }

      const getAllLink = function getAllLink() {
        if (!headerShowAll) {
          return ('');
        }

        return (
          <a
            href={headerShowAll}
            data-target="#content"
          >
            <div className="headerBox-title-link">
              {get(translations, 'txt: visi', '')}
              <span>
                <ImageSvg svg="icon-arrowright" iconClass="icon-full icon--arrowRight" />
              </span>
            </div>
          </a>
        );
      };

      return (
        <div className="headerBox">
          <div className="headerBox-title">
            {headerTitle}
            {getAllLink()}
          </div>
        </div>
      );
    };

    const getPagination = function getPagination() {
      if (!pagination || (error && loading)) {
        return ('');
      }

      // šis sagādā problēmas pie topa, kad atrasti 20, bet izmesti izdzēstie un lapā vairs nav 20
      if (activePage === 1
        && (membersLength < itemsCountPerPage
          || membersLength === MemberStore.getTotalItemsCount(section))
        && type !== 'top'
        && type !== 'highlighted'
      ) {
        return ('');
      }

      // TODO šis vēl jāpaskatās kā ir topā
      if (membersLength < itemsCountPerPage && type !== 'top' && type !== 'highlighted') {
        lastPage = true;
        totalItemsCount = (itemsCountPerPage * activePage) - 1;
      }

      return (
        <div className="content-pagination">
          <Pagination
            activePage={activePage}
            itemsCountPerPage={itemsCountPerPage}
            totalItemsCount={totalItemsCount}
            pageRangeDisplayed={10}
            innerClass="pagination clearfix"
            prevPageText={(
              <span className="btn-static">
                <span className="vcenter">
                  <span className="vcenter-inner">
                    <ImageSvg svg="icon-arrowleft" iconClass="icon--arrowLeft" />
                  </span>
                </span>
              </span>
            )}
            nextPageText={(
              <span className="btn-static">
                <span className="vcenter">
                  <span className="vcenter-inner">
                    <ImageSvg svg="icon-arrowright" iconClass="icon--arrowRight" />
                  </span>
                </span>
              </span>
            )}
            firstPageText=""
            lastPageText=""
            hideNavigation
            activeLinkClass="active"
            linkClassPrev={cx(['btn btn--b btn--oneIcon pagination-prev'], { 'btn--disabled': activePage === 1 })}
            linkClassNext={cx(['btn btn--b btn--oneIcon pagination-next'], { 'btn--disabled': lastPage })}
            onChange={self.handlePageChange}
            section={section}
          />
        </div>
      );
    };

    const loadingSpinner = function loadingSpinnerNoUserMessage() {
      if (!loading) {
        return ('');
      }
      return (<div className="loading-spinner" />);
    };

    const usersNotFoundMesssage = function usersNotFoundMesssage() {
      if (loading || !usersNotFound || !isEmpty(members)) {
        return ('');
      }
      return (
        <div className={`membersBlock block-title ptl plm${extended ? ' pbl' : ''}`}>
          {get(translations, 'txt: Nav atrasti kritērijiem atbilstoši lietotāji', 'Nav atrasti kritērijiem atbilstoši lietotāji')}
        </div>
      );
    };

    const errorMesssage = function errorMesssage() {
      if (loading || !error || !isEmpty(members)) {
        return ('');
      }

      return (
        <div className={`membersBlock block-title ptl plm${extended ? ' pbl' : ''}`}>
          <div className="flash-icon por dib vam mrxs">
            <ImageSvg svg="icon-warning" iconClass="icon--full icon--warning" />
          </div>
          <div className="dib vam tcr mlm">
            {get(translations, 'txt: Nezināma kļūda', 'Radās kļūda veicot pieprasījumu')}
          </div>
        </div>
      );
    };

    return (
      <div>
        {getBlockHeader()}
        <div className={cx(['block mbm'], { loading })} ref={this.membersGrid}>
          {loadingSpinner()}
          {usersNotFoundMesssage()}
          {errorMesssage()}
          <MembersGrid
            members={members}
            extended={extended}
            slider={slider}
            sliderAutoplay={sliderAutoplay}
            slideTotal={slideTotal}
            type={type}
            subtype={subtype}
            page={activePage}
            topNr={topNr}
            customImages={customImages}
            showDistance={showDistance}
            menuType={menuType}
          />
        </div>
        {getPagination()}
      </div>
    );
  }
}

MembersGridContainer.propTypes = {
  extended: PropTypes.bool,
  type: PropTypes.string,
  subtype: PropTypes.string,
  section: PropTypes.string,
  totalItemsCount: PropTypes.number,
  customImages: PropTypes.string,
  headerShowAll: PropTypes.string,
  headerTitle: PropTypes.string,
  slideTotal: PropTypes.number,
  slideTotalResponsive: PropTypes.number,
  slider: PropTypes.bool,
  sliderAutoplay: PropTypes.bool,
  pagination: PropTypes.bool,
  itemsCountPerPage: PropTypes.number,
  paginationUrl: PropTypes.string,
  membersId: PropTypes.arrayOf(PropTypes.string),
  page: PropTypes.number,
  checkShowDistance: PropTypes.bool,
  checkErrors: PropTypes.bool,
  menuType: PropTypes.string,
};

MembersGridContainer.defaultProps = {
  itemsCountPerPage: 20,
  pagination: false,
  slider: false,
  sliderAutoplay: false,
  slideTotal: 8,
  slideTotalResponsive: null,
  type: 'regular',
  subtype: '',
  section: 'default',
  customImages: null,
  paginationUrl: null,
  page: 1,
  totalItemsCount: 0,
  membersId: [],
  headerTitle: undefined,
  headerShowAll: '',
  extended: false,
  checkShowDistance: false,
  checkErrors: false,
  menuType: 'user',
};

export default withResizeDetector(MembersGridContainer);
